import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import { FaPaperPlane} from 'react-icons/fa'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { Triangle } from 'react-loader-spinner'

  class Profile extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
          loading: true,
          user_details: {},
          phonenumber: Number,
          current_password: '',
          new_password: '',
          confirm_new_password: '',
          image: null,
          bio: '',
          video: null,
          video_title: '',
          session_price: Number,
          weight: Number,
          height: Number,
          left_bicep: Number,
          right_bicep: Number,
          chest: Number,
          waist: Number,
          hips: Number,
          calf: Number,
          left_leg: Number,
          right_leg: Number,
          all_measurements: []
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.UploadFile = (e) => {
        this.setState({[e.target.name]: e.target.files[0]})
      }

      this.UpdateMeasurements = () => {      
        this.setState({loading: true})
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('weight', this.state.weight)
        data.append('height', this.state.height)
        data.append('left_bicep', this.state.left_bicep)
        data.append('right_bicep', this.state.right_bicep)
        data.append('chest', this.state.chest)
        data.append('waist', this.state.waist)
        data.append('hips', this.state.hips)
        data.append('calf', this.state.calf)
        data.append('left_leg', this.state.left_leg)
        data.append('right_leg', this.state.right_leg)

        axios.post(Backend_Url + 'updateMeasurements', data)
        .then((res) => {
            let result = res.data
            alert('Measurements updated.')
            this.setState({loading: false})
            window.location.reload()
        }).catch((error) => {
            console.log(error)
            alert('Something went wrong, please try again.')
            this.setSTate({loading: false})
        })
      }

      this.SaveChanges = () => {     
        this.setState({loading: true}) 
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('phonenumber', this.state.phonenumber)
        data.append('bio', this.state.bio)
        data.append('current_password', this.state.current_password)
        data.append('new_password', this.state.new_password)
        data.append('confirm_new_password', this.state.confirm_new_password)
        data.append('image', this.state.image)

        axios.post(Backend_Url + 'updateProfile', data)
        .then((res) => {
            let result = res.data

            if(result == 'Wrong current password'){
              alert('The current password you have entered is incorrect.')
              this.setState({loading: false})
            }else if(result == 'Passwords mismatch'){
              alert('Your new password and its confirmation do not match.')
              this.setState({loading: false})
            }else if(result == 'Successful'){
              alert('Successful.')
              this.setState({loading: false})
              window.location.reload()
            }
        }).catch((error) => {
            console.log(error)
            alert('Something went wrong, please try again.')
            this.setState({loading: false})
        })
      }

      this.UploadVideo = () => {    
        this.setState({loading: true})
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('name', this.state.video_title)
        data.append('video', this.state.video)

        axios.post(Backend_Url + 'addPromoVideo', data)
        .then((res) => {
            let result = res.data
            alert('Video added successfully.')
            this.setState({loading: false})
        }).catch((error) => {
            console.log(error)
            alert('Something went wrong, please try again.')
            this.setState({loading: false})
        })
      }

      this.UpdateSessionPrice = () => {   
        this.setState({loading: true}) 
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('price', this.state.session_price)

        axios.post(Backend_Url + 'updateSessionPrice', data)
        .then((res) => {
            let result = res.data
            alert('Price updated successfully.')
            this.setState({loading: false})
        }).catch((error) => {
            console.log(error)
            alert('Something went wrong, please try again.')
            this.setState({loading: false})
        })
      }

      this.DeleteAccount = () => {    
        this.setState({loading: true})
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('account_id', this.state.user_details._id.$oid)
        
        if (window.confirm('Are you sure you want to delete this account?')){
          axios.post(Backend_Url + 'deleteAccount', data)
          .then((res) => {
              let result = res.data
              if (result == 'Not authorized'){
                alert('You are not authorized to perform this action.')
                this.setState({loading: false})
              }else{
                alert('Account deleted successfully.')
                cookies.remove('token', { path: '/' });
                this.setState({loading: false})
                let port = (window.location.port ? ':' + window.location.port : '');
                window.location.href = '//' + window.location.hostname + port + '/signin';
              }
          }).catch((error) => {
              console.log(error)
              alert('Something went wrong, please try again.')
              this.setState({loading: false})
          })
        }else{
          console.log('deletion cancelled.')
          this.setState({loading: false})
        }
      }

      this.HistoricalMeasurements = () => {
        var all_measurements = this.state.all_measurements

        if(all_measurements.length == 0){
          return<div>
            No measurements recorded
          </div>
        }else{
          all_measurements.sort((b, a) => a.date.localeCompare(b.date));
          var measurements_map = all_measurements.map((item, index) => {
            return<div style={{margin: '10px', textAlign: 'left', border: '1px solid silver', borderRadius: '20px'}}>
              <Container>
                Date Recorded: {item.date.slice(0,-10)}
                <br/><br/>
                <Row>
                  <Col sm='3'>
                    Weight (kgs):
                    <br/>
                    {item.weight}
                    <br/><br/>
                  </Col>
                  <Col sm='3'>
                    Height (cms):
                    <br/>
                    {item.height}
                    <br/><br/>
                  </Col>
                  <Col sm='3'>
                    Left bicep (cms):
                    <br/>
                    {item.left_bicep}
                    <br/><br/>
                  </Col>
                  <Col sm='3'>
                    Right bicep (cms):
                    <br/>
                    {item.right_bicep}
                    <br/><br/>
                  </Col>
                </Row>
                <Row>
                  <Col sm='3'>
                    Chest (cms):
                    <br/>
                    {item.chest}
                    <br/><br/>
                  </Col>
                  <Col sm='3'>
                    Waist (cms):
                    <br/>
                    {item.waist}
                    <br/><br/>
                  </Col>
                  <Col sm='3'>
                    Hips (cms):
                    <br/>
                    {item.hips}
                    <br/><br/>
                  </Col>
                  <Col sm='3'>
                    Calf (cms):
                    <br/>
                    {item.calf}
                    <br/><br/>
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col sm='3'>
                    Left leg (cms):
                    <br/>
                    {item.left_leg}
                    <br/><br/>
                  </Col>
                  <Col sm='3'>
                    Right leg (cms):
                    <br/><br/>
                    {item.right_leg}
                    <br/><br/>
                  </Col>
                  <Col sm='3'>

                  </Col>
                  <Col sm='3'>

                  </Col>
                </Row>
              </Container>
            </div>
          })
          return<div style={{maxHeight: '600px', overflowY: 'scroll'}}>
            {measurements_map}
          </div>
        }
      }

      this.ClientRender = () => {
        var user = this.state.user_details
        var user_role = user.role

        if(user_role != 'trainer'){
          return<div>
            <Row>
              <Col sm='4' style={{textAlign: 'left'}}>
                <h6 style={{fontWeight: 'bold'}}>Weekly Schedule</h6>
                <br/>
                {user.schedule}
              </Col>
              <Col sm='4' style={{textAlign: 'left'}}>
                <h6 style={{fontWeight: 'bold'}}>Fitness Goals</h6>
                <br/>
                {user.goals}
              </Col>
              <Col sm='4' style={{textAlign: 'left'}}>
                <h6 style={{fontWeight: 'bold'}}>Training Methods</h6>
                <br/>
                {user.methods}
              </Col>
            </Row>
            <br/><br/>
            <h6 style={{fontWeight: 'bold'}}>Measurements</h6>
            <br/><br/>
            <Row>
              <Col sm='3'>
                Weight (kgs):
                <br/>
                <Input name='weight' value={this.state.weight}  placeholder='Weight' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
              <Col sm='3'>
                Height (cms):
                <br/>
                <Input name='height' value={this.state.height}  placeholder='Height' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
              <Col sm='3'>
                Left bicep (cms):
                <br/>
                <Input name='left_bicep' value={this.state.left_bicep}  placeholder='Left bicep' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
              <Col sm='3'>
                Right bicep (cms):
                <br/>
                <Input name='right_bicep' value={this.state.right_bicep}  placeholder='Right bicep' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
            </Row>
            <br/><br/>
            <Row>
              <Col sm='3'>
                Chest (cms):
                <br/>
                <Input name='chest' value={this.state.chest}  placeholder='Chest' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
              <Col sm='3'>
                Waist (cms):
                <br/>
                <Input name='waist' value={this.state.waist}  placeholder='Waist' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
              <Col sm='3'>
                Hips (cms):
                <br/>
                <Input name='hips' value={this.state.hips}  placeholder='Hips' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
              <Col sm='3'>
                Calf (cms):
                <br/>
                <Input name='calf' value={this.state.calf}  placeholder='Calf' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
            </Row>
            <br/><br/>
            <Row>
              <Col sm='3'>
                Left leg (cms):
                <br/>
                <Input name='left_leg' value={this.state.left_leg}  placeholder='Left leg' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
              <Col sm='3'>
                Right leg (cms):
                <br/>
                <Input name='right_leg' value={this.state.right_leg}  placeholder='Right leg' onChange={this.HandleChange} type='number'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
              </Col>
              <Col>

              </Col>
              <Col>

              </Col>
            </Row>
            <br/><br/>
            <Button onClick={this.UpdateMeasurements} style={{color: '#1faced', fontWeight: 'bold', border: '3px solid #1FACED', borderRadius: '20px', backgroundColor: 'inherit', width: '300px'}}>
              Update Measurements
            </Button>
            <br/><br/>
            <h6 style={{fontWeight: 'bold'}}>Historical Measurements</h6>
            <br/><br/>
            <this.HistoricalMeasurements/>
            <br/><br/><br/><br/>
          </div>
        }else{
          return<div></div>
        }
      }

      this.TrainerRender = () => {
        var user_role = this.state.user_details.role

        if(user_role == 'trainer'){
          return<div>
            <br/><br/>
            <Row style={{textAlign: 'left'}}>
              <Col sm='3'>
                <h6 style={{fontWeight: 'bold'}}>Add Promo Video</h6>
                <br/><br/>
                Video Title:
                <br/>
                <Input name='video_title' value={this.state.video_title} onChange={this.HandleChange} type='text' placeholder='Promo video title'
                  style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                <br/><br/>
                Upload Video:
                <Input name='video' onChange={this.UploadFile} type="file"
                  style={{backgroundColor: 'inherit', color: 'inherit'}}/>
                <br/><br/>
                <Button onClick={this.UploadVideo} style={{color: '#1faced', fontWeight: 'bold', border: '3px solid #1FACED', borderRadius: '20px', backgroundColor: 'inherit', width: '200px'}}>
                  Upload Promo Video
                </Button>
                <br/><br/>
              </Col>
              <Col>
                <Row>
                  <Col sm='6'>
                    Price Per Session:
                    <br/>
                    <Input name='session_price' value={this.state.session_price} onChange={this.HandleChange} type='number' placeholder='Price per session'
                      style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                  </Col>
                  <Col sm='6'>
                    <br/>
                    <Button onClick={this.UpdateSessionPrice} style={{color: '#1faced', fontWeight: 'bold', border: '3px solid #1FACED', borderRadius: '20px', backgroundColor: 'inherit', width: '200px'}}>
                      Update Session Price
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <br/><br/><br/><br/>
          </div>
        }else{
          return<div>

          </div>
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)

      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      axios.get(Backend_Url + 'getUserDetailsByAccessToken/' + cookies.get('token'))
      .then(res => {
        let result = res.data
        this.setState({
          user_details: result,
          phonenumber: result.phonenumber,
          bio: result.bio
        });
        // 
        var data2 = new FormData()
        data2.append('user_access_token', cookies.get('token'))
        data2.append('user_id', result._id.$oid)

        axios.post(Backend_Url + 'userMeasurements', data2)
        .then((res2) => {
            let result2 = res2.data
            console.log(result2)
            var recent_measurements = {}
            if(result2.length != 0){
              recent_measurements = result2[result2.length - 1]
            }
            this.setState({
              weight: recent_measurements.weight,
              height: recent_measurements.height,
              left_bicep: recent_measurements.left_bicep,
              right_bicep: recent_measurements.right_bicep,
              chest: recent_measurements.chest,
              waist: recent_measurements.waist,
              hips: recent_measurements.hips,
              calf: recent_measurements.calf,
              left_leg: recent_measurements.left_leg,
              right_leg: recent_measurements.right_leg,
              all_measurements: result2
            })
            this.setState({loading: false})
        }).catch((error) => {
            console.log(error)
        })
      })
      .catch((error) => {
        console.log(error);
      });
    }




    render() {
      if (this.state.loading == true){
        return<Row>
          <Helmet>
            <title>PROFILE- ONFIT</title>
            {/* <meta name="description" content="" /> */}
          </Helmet>
          <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
            <Container style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
              <br/>
              <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                ONFIT
              </h1>
              <br/><br/>
              <Triangle
                  color="#1FACED"
                  height={130}
                  width={130}
              />
              <h3 style={{marginTop: '50px', color: '#1FACED'}}>
                Loading...
              </h3>
              <h6 style={{marginTop: '50px'}}>
                  Taking too long to load? Check your internet connection and reload the page.
              </h6>
              <br/><br/>
            </Container>
          </div>
        </Row>
      }

        var user = this.state.user_details
      return (
        <Row>
            <Helmet>
              <title>PROFILE- ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Your Profile
              </h4>
              <br/><br/>
              <Container>
                <Row style={{textAlign: 'left'}}>
                    <Col sm='3' style={{margin: '5px'}}>
                      <h6 style={{fontWeight: 'bold'}}>Profile Photo</h6>
                      <div style={{height: '200px', width: '200px', backgroundColor: 'black', borderRadius: '50%', overflow: 'hidden',display: 'flex',  justifyContent: 'center', alignItems: 'center'}}>
                        <img src={Backend_Url + 'media/' + user.image} style={{width: 'auto', maxWidth: '200px', height: 'auto', maxHeight: '200px'}}/>
                      </div>
                      <br/><br/>
                      <span style={{fontWeight: 'bold'}}>Change Photo:</span>
                      <Input name='image' onChange={this.UploadFile} type="file"
                        style={{backgroundColor: 'inherit', color: 'inherit'}}/>
                      <br/>
                      <h6 style={{fontWeight: 'bold'}}>{user.firstname} {user.lastname}</h6>
                      <h6>{user.email}</h6>
                      <br/>
                      <span style={{fontWeight: 'bold'}}>Joined:</span> {user.date_joined}
                      <br/><br/>
                      <Button onClick={this.DeleteAccount} style={{color: '#ffffff', fontWeight: 'bold', border: '3px solid red', borderRadius: '20px', backgroundColor: 'red'}}>
                        Delete Account
                      </Button>
                      <br/>
                    </Col>
                    <Col style={{margin: '5px'}}>
                      <Row>
                        <Col>
                          <span style={{fontWeight: 'bold'}}>Bio:</span>
                          <br/>
                          <textarea name='bio' value={this.state.bio} onChange={this.HandleChange} type='textarea' placeholder='Tell the community about yourself' rows='4'
                            style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}>
                          </textarea>
                        </Col>
                      </Row>
                      <br/><br/>
                      <Row>
                        <Col>
                          <span style={{fontWeight: 'bold'}}>Phonenumber:</span>
                          <br/>
                          <Input name='phonenumber' value={this.state.phonenumber} onChange={this.HandleChange} type='number' placeholder='Phonenumber'
                            style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                        </Col>
                        <Col>

                        </Col>
                      </Row>
                      <br/><br/><br/>
                      <span style={{fontWeight: 'bold'}}>Change Password:</span>
                      <Row>
                        <Col sm='4'>
                          <Input name='current_password' value={this.state.current_password} onChange={this.HandleChange} type='password' placeholder='Current password'
                            style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                          <br/>
                        </Col>
                        <Col sm='4'>
                          <Input name='new_password' value={this.state.new_password} onChange={this.HandleChange} type='password' placeholder='New password'
                            style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                          <br/>
                        </Col>
                        <Col sm='4'>
                          <Input name='confirm_new_password' value={this.state.confirm_new_password} onChange={this.HandleChange} type='password' placeholder='Confirm new password'
                            style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                          <br/>
                        </Col>
                      </Row>
                      <br/><br/>
                      <Button onClick={this.SaveChanges} style={{color: '#1faced', fontWeight: 'bold', border: '3px solid #1FACED', borderRadius: '20px', backgroundColor: 'inherit', width: '200px'}}>
                        Save Changes
                      </Button>
                    </Col>
                </Row>
                <br/><br/>
                <this.TrainerRender/>
                <this.ClientRender/>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Profile);